import { render, staticRenderFns } from "./RemoveFile.vue?vue&type=template&id=0863d5bd"
import script from "./RemoveFile.vue?vue&type=script&lang=js"
export * from "./RemoveFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports